const RequestData = () => {
    return {
        requests: [
            {
                requestInfo: {
                    requestId: 'DAoBDA0FDgwDBQoDBAsCCQ',
                    userId: 'ceno',
                    advocateId: 'sblake',
                    advocateApproval: 'DENIED',
                    resourceApproval: 'PENDING',
                    requestStatus: 'DENIED',
                    requestDate: 1469909400000,
                    justification: 'It should be fun to read!',
                    messages: [
                        {
                            user: {
                                userId: 'sblake',
                                userName: {
                                    first: 'Siobhan',
                                    last: 'Blake'
                                },
                                email: 'sblake@icct.com'
                            },
                            text: `It might indeed be fun to read, but it's not the kind of thing we supply at ICC.`,
                            date: 1469909412749
                        },
                        {
                            user: {
                                userId: 'ceno',
                                userName: {
                                    first: 'Caleb',
                                    last: 'eno'
                                },
                                email: 'ceno@icct.com'
                            },
                            text: 'aww......',
                            date: 1469909460201
                        }
                    ]
                },
                bookInfo: {
                    author: "Martin Gardner",
                    title: "The Colossal Book of Mathematics: Classic Puzzles, Paradoxes, and Problems",
                    edition: "First Edition",
                    ISBN: 393020231,
                    binding: "Hardcover",
                    publisher: "W. W. Norton and Company",
                    publicationDate: "2001-09-17",
                    imageLinks: {
                        small: "http://ecx.images-amazon.com/images/I/518cHJp6lML._SL75_.jpg",
                        medium: "http://ecx.images-amazon.com/images/I/518cHJp6lML._SL160_.jpg",
                        large: "http://ecx.images-amazon.com/images/I/518cHJp6lML.jpg"
                    },
                    productLink: "http://www.amazon.com/Colossal-Book-Mathematics-Paradoxes-Problems/dp/03930…nkCode%3Dxm2%26camp%3D2025%26creative%3D165953%26creativeASIN%3D0393020231",
                    price: {
                        Amount: 2214,
                        CurrencyCode: "USD",
                        FormattedPrice: "$22.14"
                    },
                    viewMoreOffersLink: "http://www.amazon.com/gp/offer-listing/0393020231%3FSubscriptionId%3DAKIAJZ…nkCode%3Dxm2%26camp%3D2025%26creative%3D386001%26creativeASIN%3D0393020231",
                    primeEligible: true
                }
            },
            {
                requestInfo: {
                    requestId: 'AQEADg8HBAEEDwoCBAkNCQ',
                    userId: 'ceno',
                    advocateId: 'sblake',
                    advocateApproval: 'PENDING',
                    resourceApproval: 'PENDING',
                    requestStatus: 'AWAITING_APPROVAL',
                    requestDate: 1469942637993,
                    // requestDate: new Date().getTime(),
                    justification: `Need this for a class I'm taking`,
                    messages: []
                },
                bookInfo: {
                    author: "Scott Rogers",
                    title: "Level Up! The Guide to Great Video Game Design",
                    edition: 2,
                    ISBN: 1118877160,
                    binding: "Paperback",
                    publisher: "Wiley",
                    publicationDate: "2014-04-28",
                    imageLinks: {
                        small: "http://ecx.images-amazon.com/images/I/51D5gA--hPL._SL75_.jpg",
                        medium: "http://ecx.images-amazon.com/images/I/51D5gA--hPL._SL160_.jpg",
                        large: "http://ecx.images-amazon.com/images/I/51D5gA--hPL.jpg"
                    },
                    productLink: "http://www.amazon.com/Level-Guide-Great-Video-Design/dp/1118877160%3FSubscr…nkCode%3Dxm2%26camp%3D2025%26creative%3D165953%26creativeASIN%3D1118877160",
                    price: {
                        Amount: 3000,
                        CurrencyCode: "USD",
                        FormattedPrice: "$30.00"
                    },
                    viewMoreOffersLink: "http://www.amazon.com/gp/offer-listing/1118877160%3FSubscriptionId%3DAKIAJZ…nkCode%3Dxm2%26camp%3D2025%26creative%3D386001%26creativeASIN%3D1118877160",
                    primeEligible: true
                }
            },
            {
                requestInfo: {
                    requestId: 'AwwHAQIHCgUDBQ0NBAIOAQ',
                    userId: 'ceno',
                    advocateId: 'sblake',
                    advocateApproval: 'APPROVED',
                    resourceApproval: 'APPROVED',
                    requestStatus: 'ORDERED',
                    requestDate: 1469973480628,
                    justification: `Requested for a class I'm taking.`,
                    messages: [
                        {
                            user: {
                                userId: 'sblake',
                                userName: {
                                    first: 'Siobhan',
                                    last: 'Blake'
                                },
                                email: 'sblake@icct.com'
                            },
                            text: `What class is this for?`,
                            date: 1469973556846
                        },
                        {
                            user: {
                                userId: 'ceno',
                                userName: {
                                    first: 'Caleb',
                                    last: 'eno'
                                },
                                email: 'ceno@icct.com'
                            },
                            text: `It's about how game design principles can improve your overall skills as a developer.`,
                            date: 1469973608934
                        },
                        {
                            user: {
                                userId: 'sblake',
                                userName: {
                                    first: 'Siobhan',
                                    last: 'Blake'
                                },
                                email: 'sblake@icct.com'
                            },
                            text: `Sounds fun!`,
                            date: 1469973641162
                        }
                    ]
                },
                bookInfo: {
                    author: "Jesse Schell",
                    title: "The Art of Game Design: A Deck of Lenses, Second Edition",
                    edition: "2nd",
                    ISBN: 692288872,
                    binding: "Cards",
                    publisher: "Schell Games",
                    publicationDate: "2014-11-06",
                    imageLinks: {
                        small: "http://ecx.images-amazon.com/images/I/51l98hNDiQL._SL75_.jpg",
                        medium: "http://ecx.images-amazon.com/images/I/51l98hNDiQL._SL160_.jpg",
                        large: "http://ecx.images-amazon.com/images/I/51l98hNDiQL.jpg"
                    },
                    productLink: "http://www.amazon.com/Art-Game-Design-Lenses-Second/dp/0692288872%3FSubscri…nkCode%3Dxm2%26camp%3D2025%26creative%3D165953%26creativeASIN%3D0692288872",
                    price: {
                        Amount: 2331,
                        CurrencyCode: "USD",
                        FormattedPrice: "$23.31"
                    },
                    viewMoreOffersLink: "http://www.amazon.com/gp/offer-listing/0692288872%3FSubscriptionId%3DAKIAJZ…nkCode%3Dxm2%26camp%3D2025%26creative%3D386001%26creativeASIN%3D0692288872",
                    primeEligible: true
                }
            },
            {
                requestInfo: {
                    requestId: 'DQwBCQ8GCwMCBgoIBA0LDQ',
                    userId: 'ceno',
                    advocateId: 'sblake',
                    advocateApproval: 'APPROVED',
                    resourceApproval: 'APPROVED',
                    requestStatus: 'DELIVERED',
                    requestDate: 1469973749176,
                    justification: `Essential reading for mastering JavaScript.`,
                    messages: [
                        {
                            user: {
                                userId: 'sblake',
                                userName: {
                                    first: 'Siobhan',
                                    last: 'Blake'
                                },
                                email: 'sblake@icct.com'
                            },
                            text: `We should get this for more of our developers!`,
                            date: 1469973820121
                        },
                        {
                            user: {
                                userId: 'sblake',
                                userName: {
                                    first: 'Siobhan',
                                    last: 'Blake'
                                },
                                email: 'sblake@icct.com'
                            },
                            text: `I have your book and will bring it to CAS this week.`,
                            date: 1469973858798
                        }
                    ]
                },
                bookInfo: {
                    author: "Douglas Crockford",
                    title: "JavaScript: The Good Parts",
                    edition: "1st",
                    ISBN: 596517742,
                    binding: "Paperback",
                    publisher: "O'Reilly Media",
                    publicationDate: "2008-05",
                    imageLinks: {
                        small: "http://ecx.images-amazon.com/images/I/5166ztxOm9L._SL75_.jpg",
                        medium: "http://ecx.images-amazon.com/images/I/5166ztxOm9L._SL160_.jpg",
                        large: "http://ecx.images-amazon.com/images/I/5166ztxOm9L.jpg"
                    },
                    productLink: "http://www.amazon.com/JavaScript-Good-Parts-Douglas-Crockford/dp/0596517742…nkCode%3Dxm2%26camp%3D2025%26creative%3D165953%26creativeASIN%3D0596517742",
                    price: {
                        Amount: 2081,
                        CurrencyCode: "USD",
                        FormattedPrice: "$20.81"
                    },
                    viewMoreOffersLink: "http://www.amazon.com/gp/offer-listing/0596517742%3FSubscriptionId%3DAKIAJZ…nkCode%3Dxm2%26camp%3D2025%26creative%3D386001%26creativeASIN%3D0596517742",
                    primeEligible: true
                }
            },
            {
                requestInfo: {
                    requestId: 'BQAMCgMDBg4ACwAKBAMMDw',
                    userId: 'ceno',
                    advocateId: 'afiore',
                    advocateApproval: 'PENDING',
                    resourceApproval: 'PENDING',
                    requestStatus: 'AWAITING_APPROVAL',
                    requestDate: 1469973914330,
                    justification: `Learning from the best.`,
                    messages: []
                },
                bookInfo: {
                    author: "Scott Preston",
                    title: "Learn HTML5 and JavaScript for iOS: Web Standards-based Apps for iPhone, iPad, and iPod touch",
                    edition: 2012,
                    ISBN: 1430240385,
                    binding: "Paperback",
                    publisher: "Apress",
                    publicationDate: "2012-05-15",
                    imageLinks: {
                        small: "http://ecx.images-amazon.com/images/I/411MQwWjF0L._SL75_.jpg",
                        medium: "http://ecx.images-amazon.com/images/I/411MQwWjF0L._SL160_.jpg",
                        large: "http://ecx.images-amazon.com/images/I/411MQwWjF0L.jpg"
                    },
                    productLink: "http://www.amazon.com/Learn-HTML5-JavaScript-iOS-Standards-based/dp/1430240…nkCode%3Dxm2%26camp%3D2025%26creative%3D165953%26creativeASIN%3D1430240385",
                    price: {
                        Amount: 2711,
                        CurrencyCode: "USD",
                        FormattedPrice: "$27.11"
                    },
                    viewMoreOffersLink: "http://www.amazon.com/gp/offer-listing/1430240385%3FSubscriptionId%3DAKIAJZ…nkCode%3Dxm2%26camp%3D2025%26creative%3D386001%26creativeASIN%3D1430240385",
                    primeEligible: true
                }
            },
            {
                requestInfo: {
                    requestId: 'AAkIDQYFDAQEDQIKBA8PDg',
                    userId: '',
                    advocateId: '',
                    advocateApproval: 'PENDING',
                    resourceApproval: 'PENDING',
                    requestStatus: '',
                    requestDate: '',
                    justification: '',
                    messages: [
                        {
                            user: {
                                userId: '',
                                userName: {
                                    first: '',
                                    last: ''
                                },
                                email: ''
                            },
                            text: '',
                            date: ''
                        }
                    ]
                },
                bookInfo: {
                    author: [
                        "James Bender",
                        "Jeff McWherter"
                    ],
                    title: "Professional Test Driven Development with C#: Developing Real World Applications with TDD",
                    edition: 1,
                    ISBN: "047064320X",
                    binding: "Paperback",
                    publisher: "Wrox",
                    publicationDate: "2011-05-10",
                    imageLinks: {
                        small: "http://ecx.images-amazon.com/images/I/51XYxuW-W1L._SL75_.jpg",
                        medium: "http://ecx.images-amazon.com/images/I/51XYxuW-W1L._SL160_.jpg",
                        large: "http://ecx.images-amazon.com/images/I/51XYxuW-W1L.jpg"
                    },
                    productLink: "http://www.amazon.com/Professional-Test-Driven-Development-Applications/dp/…nkCode%3Dxm2%26camp%3D2025%26creative%3D165953%26creativeASIN%3D047064320X",
                    price: {
                        Amount: 3128,
                        CurrencyCode: "USD",
                        FormattedPrice: "$31.28"
                    },
                    viewMoreOffersLink: "http://www.amazon.com/gp/offer-listing/047064320X%3FSubscriptionId%3DAKIAJZ…nkCode%3Dxm2%26camp%3D2025%26creative%3D386001%26creativeASIN%3D047064320X",
                    primeEligible: true
                }
            },
            {
                requestInfo: {
                    requestId: 'Bw8CDQICDQwMCQYNBAQMBA',
                    userId: '',
                    advocateId: '',
                    advocateApproval: 'PENDING',
                    resourceApproval: 'PENDING',
                    requestStatus: '',
                    requestDate: '',
                    justification: '',
                    messages: [
                        {
                            user: {
                                userId: '',
                                userName: {
                                    first: '',
                                    last: ''
                                },
                                email: ''
                            },
                            text: '',
                            date: ''
                        }
                    ]
                },
                bookInfo: {
                    author: "Robert C. Martin",
                    title: "Clean Code: A Handbook of Agile Software Craftsmanship",
                    edition: 1,
                    ISBN: 132350882,
                    binding: "Paperback",
                    publisher: "Prentice Hall",
                    publicationDate: "2008-08-11",
                    imageLinks: {
                        small: "http://ecx.images-amazon.com/images/I/515iEcDr1GL._SL75_.jpg",
                        medium: "http://ecx.images-amazon.com/images/I/515iEcDr1GL._SL160_.jpg",
                        large: "http://ecx.images-amazon.com/images/I/515iEcDr1GL.jpg"
                    },
                    productLink: "http://www.amazon.com/Clean-Code-Handbook-Software-Craftsmanship/dp/0132350…nkCode%3Dxm2%26camp%3D2025%26creative%3D165953%26creativeASIN%3D0132350882",
                    price: {
                        Amount: 2866,
                        CurrencyCode: "USD",
                        FormattedPrice: "$28.66"
                    },
                    viewMoreOffersLink: "http://www.amazon.com/gp/offer-listing/0132350882%3FSubscriptionId%3DAKIAJZ…nkCode%3Dxm2%26camp%3D2025%26creative%3D386001%26creativeASIN%3D0132350882",
                    primeEligible: true
                }
            },
            {
                requestInfo: {
                    requestId: 'Bg4OBwoEAAUFCwEEBAkLAg',
                    userId: '',
                    advocateId: '',
                    advocateApproval: 'PENDING',
                    resourceApproval: 'PENDING',
                    requestStatus: '',
                    requestDate: '',
                    justification: '',
                    messages: [
                        {
                            user: {
                                userId: '',
                                userName: {
                                    first: '',
                                    last: ''
                                },
                                email: ''
                            },
                            text: '',
                            date: ''
                        }
                    ]
                },
                bookInfo: {
                    author: "William E. Shotts Jr.",
                    title: "The Linux Command Line: A Complete Introduction",
                    edition: 1,
                    ISBN: 1593273894,
                    binding: "Paperback",
                    publisher: "No Starch Press",
                    publicationDate: "2012-01-17",
                    imageLinks: {
                        small: "http://ecx.images-amazon.com/images/I/516heTllggL._SL75_.jpg",
                        medium: "http://ecx.images-amazon.com/images/I/516heTllggL._SL160_.jpg",
                        large: "http://ecx.images-amazon.com/images/I/516heTllggL.jpg"
                    },
                    productLink: "http://www.amazon.com/Linux-Command-Line-Complete-Introduction/dp/159327389…nkCode%3Dxm2%26camp%3D2025%26creative%3D165953%26creativeASIN%3D1593273894",
                    price: {
                        Amount: 2631,
                        CurrencyCode: "USD",
                        FormattedPrice: "$26.31"
                    },
                    viewMoreOffersLink: "http://www.amazon.com/gp/offer-listing/1593273894%3FSubscriptionId%3DAKIAJZ…nkCode%3Dxm2%26camp%3D2025%26creative%3D386001%26creativeASIN%3D1593273894",
                    primeEligible: true
                }
            },
            {
                requestInfo: {
                    requestId: 'CgoJDwYEBQ8BBwkCBAkHDQ',
                    userId: '',
                    advocateId: '',
                    advocateApproval: 'PENDING',
                    resourceApproval: 'PENDING',
                    requestStatus: '',
                    requestDate: '',
                    justification: '',
                    messages: [
                        {
                            user: {
                                userId: '',
                                userName: {
                                    first: '',
                                    last: ''
                                },
                                email: ''
                            },
                            text: '',
                            date: ''
                        }
                    ]
                },
                bookInfo: {
                    author: "Juho Vepsäläinen",
                    title: "SurviveJS - Webpack and React: From apprentice to master",
                    edition: 2,
                    ISBN: "152391050X",
                    binding: "Paperback",
                    publisher: "CreateSpace Independent Publishing Platform",
                    publicationDate: "2016-02-15",
                    imageLinks: {
                        small: "http://ecx.images-amazon.com/images/I/41ZzWbhlaNL._SL75_.jpg",
                        medium: "http://ecx.images-amazon.com/images/I/41ZzWbhlaNL._SL160_.jpg",
                        large: "http://ecx.images-amazon.com/images/I/41ZzWbhlaNL.jpg"
                    },
                    productLink: "http://www.amazon.com/SurviveJS-Webpack-React-apprentice-master/dp/15239105…nkCode%3Dxm2%26camp%3D2025%26creative%3D165953%26creativeASIN%3D152391050X",
                    price: {
                        Amount: 1999,
                        CurrencyCode: "USD",
                        FormattedPrice: "$19.99"
                    },
                    viewMoreOffersLink: "http://www.amazon.com/gp/offer-listing/152391050X%3FSubscriptionId%3DAKIAJZ…nkCode%3Dxm2%26camp%3D2025%26creative%3D386001%26creativeASIN%3D152391050X",
                    primeEligible: true
                }
            },
            {
                requestInfo: {
                    requestId: 'AwADCAAHBQEBAwkJBAwECA',
                    userId: '',
                    advocateId: '',
                    advocateApproval: 'PENDING',
                    resourceApproval: 'PENDING',
                    requestStatus: '',
                    requestDate: '',
                    justification: '',
                    messages: [
                        {
                            user: {
                                userId: '',
                                userName: {
                                    first: '',
                                    last: ''
                                },
                                email: ''
                            },
                            text: '',
                            date: ''
                        }
                    ]
                },
                bookInfo: {
                    author: "Joseph Connor",
                    title: "Programming: Computer Programming for Beginners - Learn the Basics of Java, SQL and C++",
                    edition: 2,
                    ISBN: 1518662587,
                    binding: "Paperback",
                    publisher: "CreateSpace Independent Publishing Platform",
                    publicationDate: "2015-08-17",
                    imageLinks: {
                        small: "http://ecx.images-amazon.com/images/I/51lZBHKsmjL._SL75_.jpg",
                        medium: "http://ecx.images-amazon.com/images/I/51lZBHKsmjL._SL160_.jpg",
                        large: "http://ecx.images-amazon.com/images/I/51lZBHKsmjL.jpg"
                    },
                    productLink: "http://www.amazon.com/Programming-Computer-Beginners-Learn-Basics/dp/151866…nkCode%3Dxm2%26camp%3D2025%26creative%3D165953%26creativeASIN%3D1518662587",
                    price: {
                        Amount: 1034,
                        CurrencyCode: "USD",
                        FormattedPrice: "$10.34"
                    },
                    viewMoreOffersLink: "http://www.amazon.com/gp/offer-listing/1518662587%3FSubscriptionId%3DAKIAJZ…nkCode%3Dxm2%26camp%3D2025%26creative%3D386001%26creativeASIN%3D1518662587",
                    primeEligible: true
                }
            }
        ]
    }
};

export default RequestData;

// isbns
// 0393020231 // mathematics
// 1118877160 // Level up
// 0692288872 // Art of design
// 0596517742 // Javascript the good parts
// 1430240385 // S preston
// 047064320X // Bender
// 0132350882 // Clean Code
// 1593273894 // Linus Command line
// 152391050X // React
// 1518662587 // coding



/** WEBPACK FOOTER **
 ** ./src/data/requests.js
 **/